import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import { RouterView } from 'vue-router';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { languages } from './utils/language';
import store from './store';
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const {
      locale: language
    } = useI18n();
    const locale = computed(() => languages[language.value].elMessage);
    return (_ctx, _cache) => {
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: locale.value
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_unref(RouterView), {
          key: _unref(store).state.app.pageKey
        }))]),
        _: 1
      }, 8, ["locale"]);
    };
  }
});